export const initHowItWorksStepper = () => {
  const howItWorksStepper = document.getElementById("how-it-works-stepper") as HTMLDivElement;

  if (!howItWorksStepper) {
    return;
  }

  // Get all elements
  const icons = howItWorksStepper.querySelector(".icons") as HTMLDivElement;
  const iconElements = icons?.querySelectorAll(".icon");
  const totalIcons = iconElements?.length || 0;

  // Collect all step containers
  const stepContainers = [
    howItWorksStepper.querySelector(".steps-md"),
    howItWorksStepper.querySelector(".steps-sm"),
    howItWorksStepper.querySelector(".steps-sm-content"),
  ].filter(Boolean) as HTMLDivElement[];

  // Get all step NodeLists
  const allStepLists = stepContainers
    .map((container) => container.querySelectorAll(".step"))
    .filter((steps) => steps.length > 0);

  // Single shared index for everything
  let currentIndex = 0;
  let intervalId: ReturnType<typeof setInterval>;

  // Calculate max steps once (they don't change)
  const maxSteps = Math.max(totalIcons, ...allStepLists.map((steps) => steps.length));

  // Update function for all elements
  function updateAll(newIndex?: number) {
    // If a specific index is provided, use it
    if (newIndex !== undefined) {
      currentIndex = newIndex;
    }

    // Update icons
    if (icons && totalIcons > 0) {
      const offset = -currentIndex * 100 * (1 / 3);
      icons.style.transform = `translateX(${offset}%)`;
    }

    // Update all step containers
    allStepLists.forEach((steps) => {
      steps.forEach((step, index) => {
        step.classList.toggle("active", index === currentIndex);
      });
    });
  }

  // Auto-advance function
  function autoAdvance() {
    currentIndex = (currentIndex + 1) % maxSteps;
    updateAll();
  }

  // Add click handlers to all steps
  allStepLists.forEach((steps) => {
    steps.forEach((step, index) => {
      step.addEventListener("click", () => {
        // Update to clicked index
        updateAll(index);

        // Reset the interval to prevent immediate auto-advance
        clearInterval(intervalId);
        intervalId = setInterval(autoAdvance, 3000);
      });
    });
  });

  // Start the interval
  intervalId = setInterval(autoAdvance, 3000);
};
